import { render, staticRenderFns } from "./MiningPopup.vue?vue&type=template&id=fdda77b0&scoped=true"
import script from "./MiningPopup.vue?vue&type=script&lang=js"
export * from "./MiningPopup.vue?vue&type=script&lang=js"
import style0 from "./MiningPopup.vue?vue&type=style&index=0&id=fdda77b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdda77b0",
  null
  
)

export default component.exports